// extracted by mini-css-extract-plugin
export default {"tableWrap":"ICDGroup_tableWrap__kpemZ"};